import React, { FC } from 'react';
import styled from 'styled-components';

import { getStyledThemeColor } from '@portals/utils';

import { ReactComponent as ClockIcon } from '../../../../../../../../assets/img/icons/clock.svg';
import { ReactComponent as SuccessIcon } from '../../../../../../../../assets/img/icons/success.svg';
import { ReactComponent as WarningIcon } from '../../../../../../../../assets/img/icons/warning.svg';

interface VerificationStateProps {
  newDomain: string;
}

export const Verifying: FC<VerificationStateProps> = ({ newDomain }) => (
  <Container>
    <ClockIcon />
    <div className="label d-flex flex-column">
      <span>Verifying new domain...</span>
      <span className="domain">{newDomain}</span>
    </div>
  </Container>
);

export const Failure: FC<VerificationStateProps> = ({ newDomain }) => (
  <Container>
    <WarningIcon />

    <div className="label d-flex flex-column">
      <span>Verification failed</span>
      <span className="domain">{newDomain}</span>
    </div>
  </Container>
);

export const Success: FC<VerificationStateProps> = ({ newDomain }) => (
  <Container>
    <SuccessIcon />

    <div className="label d-flex flex-column">
      <span>Domain changed successfully</span>
      <span className="domain">{newDomain}</span>
    </div>
  </Container>
);

const Container = styled.div`
  display: grid;
  grid-template-columns: 20px 1fr;
  grid-column-gap: 15px;
  align-items: center;

  .label {
    color: ${getStyledThemeColor('dark')};
    font-size: 12px;
  }

  .domain {
    color: ${getStyledThemeColor('gray600')};
  }
`;
